import type { ComponentType } from "react";
import { DiscountCodesDashboard } from "./discount-codes";
import { B2bLabVisitsDashboard } from "./b2b-lab-visits";
import { B2bEconomicsDashboard } from "./b2b-economics";
import { CohortConversionDashboard } from "./cohort-conversion";
import { ChurnDashboard } from "./churn";
import { FeedbackDashboard } from "./feedback";
import { LeadsDashboard } from "./leads";
import { LabUsageDashboard } from "./lab-usage";
import { ReferralsDashboard } from "./referrals";
import { CustomerAttributionDashboard } from "./customer-attribution";
import { HealthOutcomesDashboard } from "./health-outcomes-live";
import { CustomerPortraitDashboard } from "./customer-portrait-live";
import { HelfoRulesV2Dashboard } from "./helfo-rules-v2";

export type DashboardComponent = ComponentType;

/**
 * Maps a dashboard `id` (matching the backend definition) to its bespoke
 * React component. Add a new entry here when you ship a new dashboard.
 */
export const dashboardComponents: Record<string, DashboardComponent> = {
  "discount-codes": DiscountCodesDashboard,
  "b2b-lab-visits": B2bLabVisitsDashboard,
  "b2b-economics": B2bEconomicsDashboard,
  "cohort-conversion": CohortConversionDashboard,
  churn: ChurnDashboard,
  feedback: FeedbackDashboard,
  leads: LeadsDashboard,
  "lab-usage": LabUsageDashboard,
  referrals: ReferralsDashboard,
  "customer-attribution": CustomerAttributionDashboard,
  "health-outcomes": HealthOutcomesDashboard,
  "customer-portrait": CustomerPortraitDashboard,
  "helfo-rules-v2": HelfoRulesV2Dashboard,
};
